import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { formApiUrl, Translations } from '../../../../utils/';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

import { setCurrentProductAllAccounts, setExistingEntityData } from '../../actions/actionCreator';
//style
import './styles.css';

class CreateNewReportAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: {},
      unqiueBankName: [
        {
          name: 'HSBC',
          value: 'hsbc'
        }
      ]
    }
  }

  componentWillMount() {

    let apiURL = "/aemData/formData/json_create-newReportAccount";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }

    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
      });

    let _caseId = Object.keys(this.props.cases)[0]
    let url = `${'/product/other/accounts/'}${_caseId}${'/country/bankNames'}`
    let _unqiueBankName = [...this.state.unqiueBankName];
    eapiClient(url)
      .then(({ data }) => {
        _unqiueBankName.push(...data.responseData)
        let obj = {
          name: 'Other',
          value: 'other'
        }
        _unqiueBankName.push(obj)
        this.setState({
          unqiueBankName: _unqiueBankName
        })
      })
  }

  getFormData = (formData) => {
    let fromDataFromSession = window.sessionStorage.getItem('previousPageStateLevel2');
    let parseData = JSON.parse(fromDataFromSession);
    let _formData = {
      ...formData,
      accountHolder: parseData.formData.accountHolder,
      otherAccountHolder: parseData.formData.otherAccountHolder !== undefined ? parseData.formData.otherAccountHolder : undefined,
      otherEntityAccountHolder: parseData.formData.otherEntityAccountHolder !== undefined ? parseData.formData.otherEntityAccountHolder : undefined,
      tradingName: parseData.formData.otherEntityAccountHolder !== undefined ? parseData.formData.otherEntityAccountHolder.value === 'other' ? parseData.formData.tradingName : undefined : parseData.formData.tradingName,
      bankName: formData.bankName !== undefined ? formData.bankName.value !== 'HSBC' ? formData.bankName.name : "HSBC" : "",
      hsbcAccount: formData.bankName !== undefined ? formData.bankName.value === 'HSBC' ? 'hsbc' : undefined : undefined
    }
    this.setState({ formData: _formData });
  }

  onFormSubmit = (event, apiURL) => {
    var requestData = { ...this.state.formData };
    if (this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":echannelId", this.props.echannelId), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data, status }) => {
        if (status === 201 || status === 200) {
          let _caseId = Object.keys(this.props.cases)[0]
          let accountUrl = "/product/other/accounts/" + _caseId;
          let _url = "/entities/existing-organisations/" + _caseId;
          eapiClient(accountUrl)
            .then(({ data }) => {
              this.props.setCurrentProductAllAccounts(data.responseData)
              eapiClient(_url)
                .then(({ data }) => {
                  this.props.setExistingEntityData(data.responseData)
                  this.props.history.goBack();
                });
            })
          var key = window.sessionStorage.getItem("getCurrentDropDown");
          if (data.responseData && data.responseData.otherAccounts && data.responseData.otherAccounts[data.responseData.otherAccounts.length - 1] && data.responseData.otherAccounts[data.responseData.otherAccounts.length - 1].id) {
            window.sessionStorage.setItem('key' + key, data.responseData.otherAccounts[data.responseData.otherAccounts.length - 1].id);
          }
        }
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData, fromDataFromSession, parseData;

    if (this.props.currentOtherAccount) {
      formData = {
        ...this.props.currentOtherAccount,
        bankName: {
          name: this.props.currentOtherAccount.bankName,
          value: this.props.currentOtherAccount.bankName
        }
      };

    } else {
      formData = {};
    }
    const properties = {
      formData,
      editType: 'create-new-report-other-account',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          pageState={this.state}
          bankData={this.state.unqiueBankName}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentOtherAccount = undefined;
  if (props.match.params) {
    var { otherAccountId } = props.match.params;
    if (otherAccountId && state.currentProductEchannel.currentProductAllAccounts.length > 0) {
      state.currentProductEchannel.currentProductAllAccounts.forEach(otherAccount => {
        if (otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount;
        }
      });
    }
  }
  return {
    echannelId: state.currentProductEchannel.data.id,
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    lang: state.lang,
    cases: state.cases
  };
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductAllAccounts: productEchannelAccountData => {
      dispatch(setCurrentProductAllAccounts(productEchannelAccountData))
    },
    setExistingEntityData: existingEntityData => {
      dispatch(setExistingEntityData(existingEntityData))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewReportAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductEchannel/CreateNewReportAccount.js